import * as React from 'react';
import { PaymentMethodBalanceDTO, Permission, Res } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';
import { addPrecondition } from 'pos/common';
import { Flex, Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = {
	balances: PaymentMethodBalanceDTO[]
} & Modal.Actions<void>

function getDiscrepancy(balance: PaymentMethodBalanceDTO): number {
	return balance.ActualEndAmount - balance.ExpectedEndAmount;
}

function DiscrepancyIcon({ discrepancy }: { discrepancy: number }): React.ReactNode {
	if (discrepancy < 0)
		return <i className='fa fa-arrow-circle-down text-danger'></i>;
	if (discrepancy > 0)
		return <i className='fa fa-arrow-circle-up text-success'></i>;
	return null;
}

class ShowDiscrepancy extends PosScreenClassComponent<Props, EmptyState> {


	createInitialState(_props: Props): Nullable<EmptyState> {
		return null;
	}

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected getSize(): ScreenSize {
		return 'small';
	}


	protected getScreenId(): string {
		return 'SHOW_DISCREPANCY';
	}

	protected getTitle(): string {
		return Res.Web.SHOW_DISCREPANCY();
	}

	protected getImage(): string | SvgIcon {
		return Images.CloseDay;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({
			onOK: async () => this.close(),
		});
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected getContent(): React.ReactNode {

		const totalExpected = this.props.balances.sum(x => x.ExpectedEndAmount);
		const totalActual = this.props.balances.sum(x => x.ActualEndAmount);
		const totalDiscrepancy = this.props.balances.sum(getDiscrepancy);

		return <Flex.Vertical>
			<Flex.Item>
				<Cols className='list-header'>
					<Col width='*'>{Res.Web.SHOW_DISCREPANCY_METHOD_CLM()}</Col>
					<Col width='10ex' className='text-right'>{Res.Web.SHOW_DISCREPANCY_EXPECTED_CLM()}</Col>
					<Col width='10ex' className='text-right'>{Res.Web.SHOW_DISCREPANCY_ACTUAL_CLM()}</Col>
					<Col width='10ex' className='text-right'>{Res.Web.SHOW_DISCREPANCY_DISCREPANCY_CLM()}</Col>
				</Cols>
			</Flex.Item>
			<Flex.Item size='*'>
				<ul className='list' style={{ overflowY: 'auto' }}>
					{
						this.props.balances.map(balance => <li key={balance.Method.Id}>
							<Cols>
								<Col width='2ex'><DiscrepancyIcon discrepancy={getDiscrepancy(balance)} /></Col>
								<Col width='*'>{balance.Method.Name}</Col>
								<Col width='10ex' className='text-right'>{UI.Format.asPrice(balance.ExpectedEndAmount)}</Col>
								<Col width='10ex' className='text-right'>{UI.Format.asPrice(balance.ActualEndAmount)}</Col>
								<Col width='10ex' className='text-right'>{UI.Format.asPrice(getDiscrepancy(balance))}</Col>
							</Cols>
						</li>)
					}
					<li>
						<Cols className='m-t-xxxl border-top'>
							{/* Necesito llevarme el text-18 y el font-bold _dentro_ de los cols para que el width basado en ex
							    sea igual que en resto de filas de la tabla */}
							<Col width='3ex'><span className='text-18 font-bold'><DiscrepancyIcon discrepancy={totalDiscrepancy} /></span></Col>
							<Col width='*'><span className='text-18 font-bold'>{Res.Web.SHOW_DISCREPANCY_TOTAL_LBL()}</span></Col>
							<Col width='13ex' className='text-right'><span className='text-18 font-bold'>{UI.Format.asPrice(totalExpected)}</span></Col>
							<Col width='13ex' className='text-right'><span className='text-18 font-bold'>{UI.Format.asPrice(totalActual)}</span></Col>
							<Col width='13ex' className='text-right'><span className='text-18 font-bold'>{UI.Format.asPrice(totalDiscrepancy)}</span></Col>
						</Cols>
					</li>
				</ul>
			</Flex.Item>
		</Flex.Vertical>;
	}
}

async function showDiscrepancy(balances: PaymentMethodBalanceDTO[]): Promise<Result> {
	return Modal.show(ShowDiscrepancy, { balances: balances });
}

export default addPrecondition(Preconditions.ensure(Permission.Cashdrawer_ShowDiscrepancyAmount), showDiscrepancy);